import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
} from '@backstage/plugin-techdocs-react';
import { ContentHeaderAddon } from './components/ContentHeaderAddon';
import { techdocsExtensionPlugin } from '../../../plugin';

export const ContentHeader = techdocsExtensionPlugin.provide(
  createTechDocsAddonExtension({
    name: 'ContentHeader',
    location: TechDocsAddonLocations.Content,
    component: ContentHeaderAddon,
  }),
);
